import { PlusOutlined } from "@ant-design/icons";
import Card from "features/Cart/components/Card";
import { t } from "i18next";
import ComboGiftForm from "../components/ComboGiftForm";
import { Col, Form, Row, Space, Typography } from "antd";
import { COMBO_CAMPAIGN, CONDITION_PRODUCT_TYPE, TYPE_LIMIT } from "features/Campaign/constants";
import { useState } from "react";

import ImportExcelModal from "../components/ImportExcelModal";

function GiftForm({
  dataTiersServer: initialDataTiersServer,
  form,
  handleRemoveValueComboSelected,
  isUpdate,
  promotionCampaignTiers,
  initFormGift,
  onGetDataGift,
}) {
  const [dataTiersServer, setDataTiersServer] = useState(initialDataTiersServer || []);

  const handleImportSuccess = (tierGroups) => {
    // eslint-disable-next-line no-console
    console.info("=== GIFT IMPORT DEBUG ===");
    // eslint-disable-next-line no-console
    console.info("Raw tierGroups from API:", JSON.stringify(tierGroups, null, 2));

    if (tierGroups && tierGroups.length > 0) {
      const convertedTierGroups = tierGroups.map((tierGroup) => {
        const maxQuantity = tierGroup?.maxQuantityPerSeller || 0;
        const limitType = maxQuantity > 0 ? TYPE_LIMIT.LIMIT : TYPE_LIMIT.NO_LIMIT;

        const convertedTiers = tierGroup?.promotionCampaignTiers?.map((tier) => {
          const conditionProductGroups = tier?.conditionProductGroups || [];

          const tierMaxQuantity = tier?.maxQuantityPerSeller || 0;
          const tierLimitType = tierMaxQuantity > 0 ? TYPE_LIMIT.LIMIT : TYPE_LIMIT.NO_LIMIT;

          const conditionProducts = conditionProductGroups
            .filter((group) => group?.type === CONDITION_PRODUCT_TYPE.CONDITION_PRODUCT)
            .map((product) => ({
              type: CONDITION_PRODUCT_TYPE.CONDITION_PRODUCT,
              quantity: product?.quantity || 1,
              conditionPromotionProducts: product?.conditionPromotionProducts
                ?.filter((prod) => prod?.productID || prod?.id || prod?.product?.id)
                .map((prod) => {
                  const productId = prod?.productID || prod?.id || prod?.product?.id;
                  return {
                    productID: productId,
                    product: prod?.product?.id ? prod?.product : { ...prod?.product, id: productId },
                  };
                }),
            }));

          const conditionGifts = conditionProductGroups
            .filter((group) => group?.type === CONDITION_PRODUCT_TYPE.GIFT_PRODUCT)
            .map((gift) => ({
              type: CONDITION_PRODUCT_TYPE.GIFT_PRODUCT,
              quantity: gift?.quantity || 1,
              conditionPromotionProducts: gift?.conditionPromotionProducts
                ?.filter((prod) => prod?.productID || prod?.id || prod?.product?.id)
                .map((prod) => {
                  const productId = prod?.productID || prod?.id || prod?.product?.id;
                  return {
                    productID: productId,
                    product: prod?.product?.id ? prod?.product : { ...prod?.product, id: productId },
                    budgetQuantity: prod?.budgetQuantity || 0,
                    productWarranty: prod?.productWarranty || 0,
                  };
                }),
            }));

          // Preserve all tier fields from imported data (don't lose discountType, discountAmount, budgetAmount, etc.)
          return {
            type: tier?.type || COMBO_CAMPAIGN.GIFT,
            maxQuantityPerSeller: tierLimitType === TYPE_LIMIT.NO_LIMIT ? null : tierMaxQuantity,
            minQuantity: tier?.minQuantity || 0,
            discountType: tier?.discountType || null,
            discountAmount: tier?.discountAmount !== undefined ? tier?.discountAmount : 0,
            budgetAmount: tier?.budgetAmount !== undefined ? tier?.budgetAmount : 0,
            fixedComboPrice: tier?.fixedComboPrice || 0,
            limitType: tierLimitType,
            conditionProducts: conditionProducts,
            conditionGifts: conditionGifts,
          };
        });

        return {
          type: COMBO_CAMPAIGN.GIFT,
          maxQuantityPerSeller: maxQuantity > 0 ? maxQuantity : null,
          budgetProductQuantity: tierGroup?.budgetProductQuantity || null,
          limitType: limitType,
          promotionCampaignTiers: convertedTiers,
        };
      });

      form.setFieldsValue({
        promotionCampaignTierGroupsGift: convertedTierGroups,
      });

      // eslint-disable-next-line no-console
      console.info("Converted tierGroups for form:", JSON.stringify(convertedTierGroups, null, 2));

      // Get existing data from form
      const existingData = form.getFieldValue("promotionCampaignTierGroupsGift") || [];

      // Check if existing combos are empty (no products selected)
      const hasEmptyCombos = existingData.some(
        (combo) => !combo?.promotionCampaignTiers?.[0]?.conditionProductGroups?.[0]?.conditionPromotionProducts?.length
      );

      // If there are empty combos, replace them with imported data
      // Otherwise, append imported data to existing data
      const mergedData = hasEmptyCombos ? convertedTierGroups : [...existingData, ...convertedTierGroups];

      form.setFieldsValue({
        promotionCampaignTierGroupsGift: mergedData,
      });

      setDataTiersServer(mergedData);
      onGetDataGift && onGetDataGift(mergedData);
    }
  };

  return (
    <Card
      title={
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          <Typography.Title level={5} style={{ textTransform: "uppercase", margin: 0 }}>
            {t("campaign.combo.comboGift")}
          </Typography.Title>
          <div onClick={(e) => e.stopPropagation()}>
            <ImportExcelModal
              campaignType="GIFT"
              onImportSuccess={handleImportSuccess}
              title="Upload file thông tin khuyến mãi"
            />
          </div>
        </div>
      }
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Typography.Text italic className="title-main">
          {t("campaign.combo.noteComboGift")}
        </Typography.Text>
        <Form.List name={"promotionCampaignTierGroupsGift"}>
          {(fields, { add, remove }) => {
            const handleAddCollapse = () => {
              add(initFormGift);
            };
            return (
              <Row gutter={[16, 16]}>
                {fields.map((field, index) => (
                  <Col span={24} key={field.key}>
                    <ComboGiftForm
                      form={form}
                      indexComboGift={index}
                      remove={() => remove(field.name)}
                      onRemoveValueComboSelected={handleRemoveValueComboSelected}
                      isUpdate={isUpdate}
                      promotionCampaignTiers={promotionCampaignTiers}
                      dataTiersServer={dataTiersServer}
                      onGetDataGift={onGetDataGift}
                    />
                  </Col>
                ))}
                <Col span={24}>
                  <Typography.Link underline onClick={() => handleAddCollapse()}>
                    <PlusOutlined /> {t("campaign.combo.addComboGift")}
                  </Typography.Link>
                </Col>
              </Row>
            );
          }}
        </Form.List>
      </Space>
    </Card>
  );
}

export default GiftForm;
